import { Navigate } from "@tanstack/react-router";

import { useEnableMetaAdsIntegration } from "@/features/meta-ads/useEnableMetaAdsIntegration";
import { interlude } from "@/interlude";
import { MetaAdsIntegrationPage } from "@/pages/applications/pages/metaAdsIntegration";

export const MetaAdsIntegrationPageWrapper: React.FC =
  function MetaAdsIntegrationPageWrapper() {
    const enableMetaAdsIntegration = useEnableMetaAdsIntegration();

    const statusQuery = interlude.metaAds.useGetStatus(undefined, {
      enabled: enableMetaAdsIntegration,
    });

    if (!enableMetaAdsIntegration) {
      return <Navigate to="/applications" replace />;
    }

    const isRevoked = statusQuery.data?.tokenStatus === "revoked";

    return <MetaAdsIntegrationPage showReconnectBanner={isRevoked} />;
  };
